import { UpdateMarketingPreferences, UpdateMarketingPreferencesResponse } from '@buy-viasat/types/build/bv';
import gql from 'graphql-tag';
import { client } from 'shared/containers/apollo';
import api, { apiEndpoints } from 'shared/services/axios';
import { USE_NEW_API } from 'shared/utils/dataFetchingHooks/constants';

const SEND_MARKETING_UPDATE_DETAILS = gql`
  mutation updateMarketingPreferences($input: UpdateMarketingPreferences) {
    updateMarketingPreferences(input: $input) {
      updateMarketingPreferences
    }
  }
`;

export default async function updateMarketingPreferencesAsync(
  input: UpdateMarketingPreferences,
): Promise<UpdateMarketingPreferencesResponse> {
  const { relnId, hasCustomerOptedIn } = input;

  if (USE_NEW_API) {
    // TODO: migrate this saga-driven call to the tanstack hook pattern once the customer APIs are integrated.
    const response = await api.post<UpdateMarketingPreferencesResponse>(apiEndpoints.updateMarketingPreferences, {
      relnId,
      hasCustomerOptedIn,
    });

    return response.data;
  }

  return client.mutate({
    mutation: SEND_MARKETING_UPDATE_DETAILS,
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        relnId,
        hasCustomerOptedIn,
      },
    },
  }) as UpdateMarketingPreferencesResponse;
}
